import { render, staticRenderFns } from "./resources-filter.vue?vue&type=template&id=2b981d34"
import script from "./resources-filter.vue?vue&type=script&lang=ts"
export * from "./resources-filter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports